import CachedIcon from "@mui/icons-material/Cached";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Box, IconButton, Typography } from "@mui/material";
import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_TableInstance,
  useMaterialReactTable,
} from "material-react-table";
import React, { useMemo } from "react";
import { DdFdpRouteProgressDto } from "../../app/models/responseModels/DdRouteProgressResponse";
import { CustomTooltip } from "../../components/common/tooltip/CustomToolTip";
import ProgressBar from "../../helpers/ProgressBar";
import { getDefaultMRTOptions } from "../dedicatedDelivery/DefaultMrtOptions";
import {
  DASHBORD_GRID_ACCESSOR,
  DASHBORD_GRID_HEADER,
} from "./RouteProgressTypes";

interface RouteProgressOveriviewProps {
  data: DdFdpRouteProgressDto[];
  loading: boolean;
  refresh: CallableFunction;
  handelExport:CallableFunction;
}

export const RouteProgressOverview: React.FC<RouteProgressOveriviewProps> = ({
  data,
  loading,
  refresh,
  handelExport
}) => {
  const defaultMRTOptions = getDefaultMRTOptions<DdFdpRouteProgressDto>();

  // Columns to be used on grid on landing page
  const columns = useMemo<MRT_ColumnDef<DdFdpRouteProgressDto>[]>(
    () => [
      {
        accessorKey: DASHBORD_GRID_ACCESSOR.FDPNAME,
        header: DASHBORD_GRID_HEADER.FDPNAME,
        size: 10,
      },
      {
        accessorKey: DASHBORD_GRID_ACCESSOR.TOTAL_ROUTES,
        header: DASHBORD_GRID_HEADER.TOTAL_ROUTES,
        size: 10,
      },
      {
        accessorKey: DASHBORD_GRID_ACCESSOR.TOTAL_PACKAGES,
        header: DASHBORD_GRID_HEADER.TOTAL_PACKAGES,
        size: 10,
      },
      {
        accessorKey: DASHBORD_GRID_ACCESSOR.ROUTE_PROGRESS,
        header: DASHBORD_GRID_HEADER.ROUTE_PROGRESS,
        size: 10,
        Cell: ({ cell, row }) => (
          <ProgressBar
            current={row.original.totalDeliveredPackages}
            total={row.original.totalPackages}
          />
        ),
      },
      /* {
        accessorKey: DASHBORD_GRID_ACCESSOR.AVERAGE_ROUTE_LENGTH,
        header: DASHBORD_GRID_HEADER.AVERAGE_ROUTE_LENGTH,
        size: 10,
      },
      {
        accessorKey: DASHBORD_GRID_ACCESSOR.AVERAGE_MILEAGE,
        header: DASHBORD_GRID_HEADER.AVERAGE_MILEAGE,
        size: 10,
      }, */
    ],
    []
  );

  // elements to be rendered on top of the grid
  const renderTopToolbarCustomActions = (
    table: MRT_TableInstance<DdFdpRouteProgressDto>
  ) => {
    return (
      <Box>
        <CustomTooltip arrow title="Refresh" onClick={() => refresh()}>
          <IconButton type="button">
            <CachedIcon sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>
        <CustomTooltip arrow title="Export" onClick={() => handelExport()}>
          <IconButton type="button">
            <FileDownloadOutlinedIcon sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>
      </Box>
    );
  };

  // preprare MRT V2 grid
  const table = useMaterialReactTable({
    ...defaultMRTOptions,
    columns: columns,
    data: data,
    initialState: {
      ...defaultMRTOptions.initialState,
      columnVisibility: {
        clientId: true,
      },
      sorting: [{ desc: true, id: "clientId" }],
    },
    state: {
      showProgressBars: loading,
      sorting: [{ desc: true, id: "clientId" }],
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (e) => {},
      ...defaultMRTOptions.muiTableBodyRowProps,
      sx: {
        cursor: "pointer",
      },
    }),
    renderTopToolbarCustomActions: ({ table }) =>
      renderTopToolbarCustomActions(table),
    renderBottomToolbarCustomActions: () => {
      return (
        <Typography variant="subtitle2" component="p">
          Total Rows: {data.length}
        </Typography>
      );
    },
  });

  return <MaterialReactTable table={table} />;
};
